import { render, staticRenderFns } from "./ProductPrabayarPrefix.vue?vue&type=template&id=5bb68768&"
import script from "./ProductPrabayarPrefix.vue?vue&type=script&lang=js&"
export * from "./ProductPrabayarPrefix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports